import WebView from '../components/WebView';
import AppGlobals from '../AppGlobals';

export default function() {
	return <WebView uri={AppGlobals.baseURL + 'pages/privacy?embed=1'} />;
}
